import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { PricePackagesHelpers } from '../../service/PricePackagesHelpers/PricePackagesHelpers';
import { GdStatusApprove } from '../../typings/graphql-grid';
import { Shape2, Shape2Theme } from '../Shape2/Shape2';

import './GridPricePackageStatusCell.css';

export interface PricePackageStatusCellProps {
    status: GdStatusApprove;
    isTextVisible: boolean;
}

const BLOCK = 'grid-price-package-status-cell';

export class GridPricePackageStatusCell extends React.PureComponent<PricePackageStatusCellProps> {
    render() {
        const { isTextVisible, status } = this.props;
        const statusText = PricePackagesHelpers.getPricePackageStatusText(status);

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    elem: 'status',
                    mods: {
                        type: Bem.beminize(status)
                    }
                })}
            >
                {this.getStatusIcon(statusText)}
                {isTextVisible && statusText}
            </div>
        );
    }

    private getStatusIcon(title: string) {
        const { status } = this.props;
        const statusIcon = PricePackagesHelpers.getPricePackageStatusIcon(status);

        return (
            <Shape2
                icon={statusIcon.icon}
                tone={statusIcon.tone}
                theme={Shape2Theme.light}
                width={12}
                height={12}
                cls={Bem.cls(BLOCK, 'icon')}
                title={title}
            />
        );
    }
}
